<template>
  <el-select v-model="form.brand" name="brand" :loading="loading" filterable placeholder="Select a brand" @change="$emit('input', $event)">
    <el-option v-for="brand in brands" :key="brand.id" :label="brand.name" :value="brand.id"></el-option>
  </el-select>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      brands: [],
      form: {
        brand: this.value,
      },
    }
  },
  props: {
    value: {
      default: null,
      type: String,
    },
  },
  async mounted() {
    this.loading = true
    try {
      var { data } = await this.$http.get('/brands')
    } catch(err) {
      this.$message.error(err.response.data.message)
      return false
    } finally {
      this.loading = false
    }
    this.brands = data
  },
}
</script>
